import { Injectable, signal } from '@angular/core';

/**
 * v1.6.872 — Asana 1214428404017115... (export-by-request).
 * Self-serve data export isn't available; every data-export button routes
 * the operator here, and a single globally-mounted modal
 * (ExportRequestModalComponent) tells them to email support to request it.
 *
 * One shared signal so the 20+ export buttons across orders / customers /
 * labels / marketing / analytics don't each need their own modal markup.
 */
@Injectable({ providedIn: 'root' })
export class ExportRequestService {
  /** Whether the export-request modal is currently shown. */
  readonly isOpen = signal(false);

  /** Support contact for export requests. */
  readonly supportEmail = 'support@happymealprep.com';

  open(): void {
    this.isOpen.set(true);
  }

  close(): void {
    this.isOpen.set(false);
  }
}
